import { format, parseISO } from "date-fns";

import ConversationFooter from "../../../components/ConversationFooter";
import { DATE_FORMAT } from "../../../utils/constants";
import { renderCreatedAtDateTime } from "../../../utils/datetime";
import { renderMessageNewLines } from "../../../utils/format";
import { useMessageTranslation } from "../useMessageTranslation";

const BookingDetails = ({ checkinDate, checkoutDate, numberOfGuests }) => {
  if (!checkinDate || !checkoutDate) {
    return null;
  }

  return (
    <div className="Conversation__booking-details">
      <small>
        <span role="img" aria-label="Date icon">
          &#128197;{" "}
        </span>
        <strong>{format(parseISO(checkinDate), DATE_FORMAT)}</strong> to{" "}
        <strong>{format(parseISO(checkoutDate), DATE_FORMAT)}</strong>{" "}
        {numberOfGuests && <span>for {numberOfGuests} guests </span>}
      </small>
    </div>
  );
};

const Post = ({ post, checkinDate, checkoutDate, numberOfGuests }) => {
  const { translation, isTranslationLoading, toggleTranslation } =
    useMessageTranslation(post.message);

  const attachments = post.attachment_fallback_urls
    ? post.attachment_fallback_urls.map(fallbackUrl => (
        <div key={fallbackUrl} className="Conversation__image">
          <a href={fallbackUrl} target="_blank" rel="noopener noreferrer">
            <img src={fallbackUrl} alt="Attachment" />
          </a>
        </div>
      ))
    : null;

  if (post.message) {
    let messageTypeClass;

    if (post.is_guest) {
      messageTypeClass = "received";
    } else if (post.is_guest === false) {
      messageTypeClass = "sent";
    } else {
      messageTypeClass = "third-party";
    }

    return (
      <div
        className={`Conversation__message Conversation__message--${messageTypeClass}`}
        data-testid="conversation-message"
      >
        {renderMessageNewLines(translation || post.message)}

        {attachments}

        <ConversationFooter
          datetime={post.created_at}
          operator={post.user_email}
          isTranslationLoading={isTranslationLoading}
          isTranslated={!!translation}
          toggleTranslation={toggleTranslation}
        />

        <BookingDetails
          checkinDate={checkinDate}
          checkoutDate={checkoutDate}
          numberOfGuests={numberOfGuests}
        />
      </div>
    );
  }

  if (post.attachment_fallback_urls && !post.message) {
    return attachments;
  }

  if (post.action_type) {
    return (
      <div className={`Conversation__action`}>
        <strong>{post.action_type}</strong>{" "}
        {renderCreatedAtDateTime(post.created_at)} by <em>{post.user_email}</em>
      </div>
    );
  }

  return null;
};

export default Post;
